export default __webpack_public_path__ + "static/media/quick-apply.488749b2.png";